var _style, _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPix30 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#F86B54;}\r\n\t.st2{fill:#024392;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:url(#SVGID_00000032640734047812057180000010769268385856482751_);}\r\n\t.st5{fill:url(#SVGID_00000178907395376774748850000015159037271479274924_);}\r\n\t.st6{fill:#742384;}\r\n\t.st7{clip-path:url(#SVGID_00000091010592921454269550000015822452177615750323_);}\r\n\t.st8{fill:#FDFDFD;}\r\n\t.st9{clip-path:url(#SVGID_00000148634483361028063360000000474087162920604822_);}\r\n\t.st10{fill:#05D5D2;}\r\n\t.st11{fill:url(#SVGID_00000073686432343122788650000016031404350716776365_);}\r\n\t.st12{fill:#FCFDFE;}\r\n\t.st13{fill:#FD71C8;}\r\n\t.st14{fill:url(#SVGID_00000030447542290679674070000002365992792801902268_);}\r\n\t.st15{fill:#00BF46;}\r\n\t.st16{fill:#FF0000;}\r\n\t.st17{fill:#32BCAD;}\r\n\t.st18{fill:#F9DC30;}\r\n\t.st19{fill:#CC092F;}\r\n\t.st20{fill:#0039BA;}\r\n\t.st21{fill:#E91D26;}\r\n\t.st22{fill:#D1016E;}\r\n\t.st23{fill:#182E55;}\r\n\t.st24{fill:#FFDE00;}\r\n\t.st25{fill:#0A4693;}\r\n\t.st26{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st27{fill:#FFCC00;}\r\n\t.st28{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st29{fill:#233DB4;}\r\n\t.st30{fill:#E40946;}\r\n\t.st31{fill:#081F2C;}\r\n\t.st32{fill:#F2AE13;}\r\n\t.st33{fill:#FF9900;}\r\n\t.st34{fill:#FEDC01;}\r\n\t.st35{fill:#042955;}\r\n\t.st36{fill:#0B2C53;}\r\n\t.st37{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st38{fill:#231F20;}\r\n\t.st39{fill:#F79410;}\r\n\t.st40{fill:#FF5F00;}\r\n\t.st41{fill:#EB001B;}\r\n\t.st42{fill:#F79E1B;}\r\n\t.st43{fill:#FFDD00;}\r\n\t.st44{fill:none;}\r\n\t.st45{fill:#0030A0;}\r\n\t.st46{fill-rule:evenodd;clip-rule:evenodd;fill:#0030A0;}\r\n\t.st47{fill-rule:evenodd;clip-rule:evenodd;fill:#1E447F;}\r\n\t.st48{fill:#FAFBFC;}\r\n\t.st49{fill:#F5822B;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M430.6,500H69.4C31.1,500,0,468.9,0,430.6V69.4C0,31.1,31.1,0,69.4,0h361.2C468.9,0,500,31.1,500,69.4v361.2 C500,468.9,468.9,500,430.6,500z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v-card_visa"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g972",
    transform: "translate(881.9583,610.8618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path974"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-823.8-250.7c-1.8,0-3.2-1.4-3.2-3.2v-134c0-26.4,21.5-47.8,47.8-47.8l39.5,0.1c26.3,0,47.6,21.4,47.6,47.7 v28.6c0,26.4-21.5,47.8-47.8,47.8h-55.8c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2h55.8c22.8,0,41.4-18.6,41.4-41.4v-28.6 c0-22.8-18.5-41.3-41.2-41.3l-39.5-0.1c-22.8,0-41.4,18.6-41.4,41.4v134C-820.5-252.1-822-250.7-823.8-250.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g976",
    transform: "translate(1018.428,785.3266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path978"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-785-485.3c-1.8,0-3.2-1.4-3.2-3.2v-100.1c0-8.3-6.8-15.1-15.1-15.1h-17.2c-1.8,0-3.2-1.4-3.2-3.2 c0-1.8,1.4-3.2,3.2-3.2h17.2c11.9,0,21.5,9.7,21.5,21.5v100.1C-781.8-486.7-783.3-485.3-785-485.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g980",
    transform: "translate(1049.4836,800.4702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path982",
    className: "st3",
    d: "M-819.8-637.6l-7.8-7.8c-1.9-1.9-1.9-5,0-7l7.8-7.8c1.9-1.9,5.1-1.9,7,0l7.8,7.8 c1.9,1.9,1.9,5,0,7l-7.8,7.8C-814.8-635.6-817.9-635.6-819.8-637.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g984",
    transform: "translate(1085.2297,785.4135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path986"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-729.5-550.6c-4.4,0-8.5-1.7-11.6-4.8l-39.8-39.8c-5.5-5.5-13.2-8.7-21.1-8.7h-17c-1.8,0-3.2-1.4-3.2-3.2 c0-1.8,1.4-3.2,3.2-3.2h17c9.6,0,18.9,3.8,25.6,10.6l39.8,39.8c1.9,1.9,4.4,2.9,7,2.9s5.2-1,7-2.9l39.6-39.6 c6.7-6.7,16-10.6,25.6-10.6h13.8c1.8,0,3.2,1.4,3.2,3.2c0,1.8-1.4,3.2-3.2,3.2h-13.8c-7.9,0-15.6,3.2-21.1,8.7l-39.6,39.6 C-721-552.3-725.1-550.6-729.5-550.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g988",
    transform: "translate(1085.2297,670.5434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path990"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-802-371.5h-17c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2h17c7.9,0,15.6-3.2,21.1-8.7l39.8-39.8 c3.1-3.1,7.2-4.8,11.6-4.8s8.5,1.7,11.6,4.8l39.6,39.6c5.5,5.5,13.2,8.7,21.1,8.7h13.8c1.8,0,3.2,1.4,3.2,3.2 c0,1.8-1.4,3.2-3.2,3.2h-13.8c-9.6,0-18.9-3.8-25.6-10.6l-39.6-39.6c-1.9-1.9-4.4-2.9-7-2.9s-5.2,1-7,2.9l-39.8,39.8 C-783.1-375.3-792.4-371.5-802-371.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1004",
    transform: "translate(915.1824,621.9838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1006",
    className: "st3",
    d: "M-823-276.4c-1.8,0-4,0.4-6.1,0.9v8.2c1.4,0.5,3.2,0.8,4.8,0.8c4.1,0,6-1.3,6-5 C-818.4-274.9-819.9-276.4-823-276.4 M-830.5-261.3v-16.2h1.1l0.1,0.7c1.9-0.4,4.5-1,6.3-1c1.5,0,3,0.2,4.2,1.2 c1.4,1.1,1.8,3,1.8,5c0,2.1-0.7,4.1-2.7,5.2c-1.3,0.7-3.2,1-4.7,1c-1.6,0-3.3-0.3-4.9-0.7v4.7 C-829.2-261.3-830.5-261.3-830.5-261.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1008",
    transform: "translate(931.2317,622.0317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1010",
    className: "st3",
    d: "M-822.6-276.5c-4.1,0-5.9,1.3-5.9,4.9c0,3.5,1.8,5,5.9,5s5.9-1.2,5.9-4.9 C-816.8-274.9-818.5-276.5-822.6-276.5 M-817.4-266.5c-1.3,1-3.2,1.2-5.2,1.2c-2.1,0-4-0.3-5.3-1.2c-1.5-1-2.1-2.8-2.1-4.9 s0.6-3.9,2.1-5c1.3-0.9,3.2-1.2,5.3-1.2s3.9,0.3,5.2,1.2c1.5,1.1,2.1,2.9,2.1,4.9C-815.2-269.3-815.8-267.6-817.4-266.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1012",
    transform: "translate(955.304,611.4037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1014",
    className: "st3",
    d: "M-822-255l-4.6-9.8h-0.1l-4.5,9.8h-1.2l-4.9-11.8h1.5l4.1,9.9h0.1l4.4-9.9h1.2l4.5,9.9h0.1 l4-9.9h1.4l-4.9,11.8H-822z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1016",
    transform: "translate(969.8879,622.0541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1018",
    className: "st3",
    d: "M-821.7-276.6c-3.8,0-5.1,1.6-5.3,4.1h10.6C-816.6-275.1-817.9-276.6-821.7-276.6  M-821.8-265.3c-2.3,0-3.8-0.3-4.9-1.3c-1.3-1.2-1.8-3-1.8-4.9s0.6-3.9,2.1-5c1.3-0.9,3-1.2,4.6-1.2c1.5,0,3.3,0.2,4.7,1.1 c1.7,1.1,2,3.2,2,5.4h-12.1c0,2.5,0.8,4.6,5.4,4.6c2.1,0,4.2-0.3,6.1-0.7v1.2C-817.5-265.7-819.6-265.3-821.8-265.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1020",
    transform: "translate(980.3625,611.4037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1022",
    className: "st3",
    d: "M-821.4-255v-11.8h1.1l0.1,0.7c2.5-0.6,3.7-1,5.8-1h0.2v1.3h-0.3c-1.8,0-3,0.2-5.5,0.9v9.9 h-1.4V-255z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1024",
    transform: "translate(995.301,622.0541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1026",
    className: "st3",
    d: "M-821.1-276.6c-3.8,0-5.1,1.6-5.3,4.1h10.6C-816-275.1-817.3-276.6-821.1-276.6 M-821.2-265.3 c-2.3,0-3.8-0.3-4.9-1.3c-1.3-1.2-1.8-3-1.8-4.9s0.6-3.9,2.1-5c1.3-0.9,3-1.2,4.6-1.2c1.5,0,3.3,0.2,4.7,1.1c1.7,1.1,2,3.2,2,5.4 h-12.1c0,2.5,0.8,4.6,5.4,4.6c2.1,0,4.2-0.3,6.1-0.7v1.2C-816.9-265.7-819-265.3-821.2-265.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1028",
    transform: "translate(1016.6765,621.2524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1030",
    className: "st3",
    d: "M-820.6-274.9c-1.4-0.5-3.2-0.8-4.8-0.8c-4.1,0-6,1.4-6,5c0,3.4,1.6,4.9,4.7,4.9 c1.8,0,4-0.4,6.1-0.9V-274.9z M-820.4-264.8l-0.1-0.7c-1.9,0.4-4.5,1-6.3,1c-1.5,0-3-0.2-4.2-1.2c-1.4-1.1-1.8-3-1.8-5 c0-2.1,0.7-4.1,2.7-5.2c1.3-0.8,3.2-1.1,4.8-1.1s3.3,0.3,4.9,0.7v-5.4h1.3v16.8h-1.2V-264.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1032",
    transform: "translate(1037.7957,621.9838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1034",
    className: "st3",
    d: "M-820.1-276.4c-1.8,0-4,0.4-6.1,0.9v8.2c1.5,0.5,3.2,0.8,4.8,0.8c4.1,0,6-1.3,6-5 C-815.5-274.9-817-276.4-820.1-276.4 M-816.6-266.3c-1.3,0.7-3.2,1-4.7,1c-1.7,0-3.5-0.3-5.3-0.9l-0.1,0.5h-0.9v-16.8h1.3v5.6 c1.9-0.4,4.4-1,6.2-1c1.5,0,3,0.2,4.2,1.2c1.4,1.1,1.8,3,1.8,5C-813.9-269.3-814.7-267.4-816.6-266.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1036",
    transform: "translate(1045.5945,606.9721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1038",
    className: "st3",
    d: "M-819.9-246v-1.3c0.7,0.1,1.3,0.1,1.7,0.1c1.7,0,2.8-0.5,3.7-2.5l0.4-0.9l-6.1-11.8h1.6 l5.3,10.2h0.1l5-10.2h1.5l-6.7,13.3c-1.2,2.5-2.6,3.2-4.9,3.2C-818.8-245.8-819.4-245.9-819.9-246"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1040",
    transform: "translate(1077.1594,617.9858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1042",
    className: "st3",
    d: "M-819.2-268.3h-4.6v4.1h4.6c3.2,0,4.4-0.3,4.4-2C-814.9-268.1-816.5-268.3-819.2-268.3  M-820.1-275h-3.8v4.2h3.8c3.1,0,4.4-0.4,4.4-2.1C-815.7-274.8-817.2-275-820.1-275 M-812.9-262.7c-1.6,1.1-3.7,1.1-7.5,1.1h-7 v-16.1h6.9c3.2,0,5.2,0,6.9,1c1.1,0.7,1.6,1.7,1.6,3.2c0,1.6-0.7,2.8-2.6,3.6v0.1c2,0.5,3.4,1.5,3.4,3.8 C-811.2-264.3-811.8-263.4-812.9-262.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1044",
    transform: "translate(1098.6228,616.2485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1046",
    className: "st3",
    d: "M-818.7-264.8c-1.3-0.1-2.8-0.2-4.3-0.2c-2.5,0-3.3,0.5-3.3,1.6c0,1,0.7,1.6,2.6,1.6 c1.5,0,3.4-0.3,4.9-0.7L-818.7-264.8z M-817.9-259.8l-0.1-0.7c-2,0.5-4.4,1-6.4,1c-1.2,0-2.7-0.2-3.6-0.8 c-0.9-0.6-1.3-1.6-1.3-2.9c0-1.3,0.6-2.6,1.9-3.2c1.2-0.6,2.9-0.6,4.4-0.6c1.2,0,2.9,0.1,4.3,0.2v-0.2c0-1.8-1.2-2.5-4.5-2.5 c-1.3,0-2.9,0.1-4.4,0.2v-2.4c1.6-0.1,3.6-0.2,5.1-0.2c2,0,4.2,0.2,5.5,1.1c1.3,0.9,1.6,2.3,1.6,4.1v7L-817.9-259.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1048",
    transform: "translate(1116.9124,611.4037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1050",
    className: "st3",
    d: "M-818.2-255v-6.6c0-2.1-1.1-3-3.1-3c-1.4,0-3.3,0.4-4.8,0.7v8.7h-3.3v-11.7h2.7l0.1,0.7 c2-0.5,4.4-1,6.3-1c1.4,0,3,0.2,4.1,1.2c0.9,0.8,1.3,2,1.3,3.7v7.3h-3.4V-255z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1052",
    transform: "translate(1129.2156,611.0844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1054",
    className: "st3",
    d: "M-817.9-254.4c-1.5,0-3.2-0.2-4.4-1.2c-1.4-1.1-1.8-3-1.8-5c0-1.8,0.6-3.9,2.5-5 c1.4-0.9,3.3-1.1,5.2-1.1c1.3,0,2.7,0.1,4.2,0.2v2.6c-1.2-0.1-2.7-0.2-3.8-0.2c-3.2,0-4.6,1-4.6,3.7c0,2.6,1.1,3.7,3.7,3.7 c1.5,0,3.3-0.3,4.9-0.6v2.5C-814-254.7-816.1-254.4-817.9-254.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1056",
    transform: "translate(1144.3552,620.8442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1058",
    className: "st3",
    d: "M-817.6-274.1c-3.2,0-4.5,1-4.5,3.7s1.3,3.8,4.5,3.8c3.1,0,4.5-0.9,4.5-3.7 C-813.2-272.9-814.5-274.1-817.6-274.1 M-812-265.3c-1.4,1-3.4,1.2-5.6,1.2c-2.4,0-4.3-0.3-5.7-1.2c-1.6-1.1-2.3-2.9-2.3-5 c0-2.1,0.6-3.9,2.3-5c1.4-0.9,3.3-1.2,5.7-1.2c2.4,0,4.2,0.3,5.6,1.2c1.6,1.1,2.1,2.9,2.1,5S-810.3-266.4-812-265.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1060",
    transform: "translate(1170.637,611.0844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1062",
    className: "st3",
    d: "M-817-254.4c-1.9,0-4.1-0.3-5.7-1.6c-1.9-1.6-2.5-4.1-2.5-6.7c0-2.4,0.7-5.1,3.3-6.9 c1.9-1.2,4.4-1.5,6.8-1.5c1.7,0,3.6,0.1,5.6,0.3v2.9c-1.7-0.1-3.8-0.3-5.4-0.3c-4.6,0-6.6,1.7-6.6,5.4c0,3.8,1.8,5.4,5.2,5.4 c2.1,0,4.6-0.4,7.2-0.9v2.9C-811.7-254.9-814.4-254.4-817-254.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1064",
    transform: "translate(1187.6472,621.2084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1066",
    className: "st3",
    d: "M-816.6-274.8c-2.8,0-3.8,1-4,2.8h8C-812.8-273.9-813.9-274.8-816.6-274.8 M-817.1-264.4 c-1.9,0-3.7-0.2-5-1.3c-1.4-1.1-1.9-3-1.9-4.9c0-1.8,0.6-3.8,2.3-5c1.4-1,3.3-1.2,5.2-1.2c1.6,0,3.7,0.2,5.1,1.2 c1.9,1.3,2,3.4,2,5.8h-11.3c0.1,1.8,1,3,4.4,3c2,0,4.4-0.3,6.2-0.6v2.4C-812.3-264.8-814.7-264.4-817.1-264.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1068",
    transform: "translate(1209.0212,611.4037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1070",
    className: "st3",
    d: "M-816.1-255v-6.6c0-2.1-1.1-3-3.1-3c-1.4,0-3.3,0.4-4.8,0.7v8.7h-3.3v-11.7h2.7l0.1,0.7 c2-0.5,4.4-1,6.3-1c1.4,0,3,0.2,4.1,1.2c0.9,0.8,1.3,2,1.3,3.7v7.3h-3.4V-255z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1072",
    transform: "translate(1221.3933,611.0844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1074",
    className: "st3",
    d: "M-815.8-254.4c-1.6,0-3.1-0.4-3.8-1.6c-0.6-0.8-0.8-1.9-0.8-3.6v-4.4h-2.4v-2.5h2.4l0.3-3.6h3 v3.6h4.6v2.5h-4.6v3.8c0,0.9,0.1,1.6,0.3,2.3c0.3,0.8,1.1,1.1,2.1,1.1c0.8,0,1.7-0.1,2.4-0.2v2.4 C-813.4-254.6-814.7-254.4-815.8-254.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1076",
    transform: "translate(1227.6902,611.4037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1078",
    className: "st3",
    d: "M-815.6-255v-11.8h2.7l0.1,0.7c2.1-0.6,3.8-1,5.8-1c0.1,0,0.2,0,0.4,0v2.8c-0.4,0-0.8,0-1.1,0 c-1.6,0-2.9,0.2-4.6,0.6v8.7H-815.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1080",
    transform: "translate(1248.2717,616.2485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1082",
    className: "st3",
    d: "M-815.1-264.8c-1.3-0.1-2.8-0.2-4.3-0.2c-2.5,0-3.3,0.5-3.3,1.6c0,1,0.7,1.6,2.6,1.6 c1.5,0,3.4-0.3,4.9-0.7L-815.1-264.8z M-814.4-259.8l-0.1-0.7c-2,0.5-4.4,1-6.4,1c-1.2,0-2.7-0.2-3.6-0.8 c-0.9-0.6-1.3-1.6-1.3-2.9c0-1.3,0.6-2.6,1.9-3.2c1.2-0.6,2.9-0.6,4.4-0.6c1.2,0,2.9,0.1,4.3,0.2v-0.2c0-1.8-1.2-2.5-4.5-2.5 c-1.3,0-2.9,0.1-4.4,0.2v-2.4c1.6-0.1,3.6-0.2,5.1-0.2c2,0,4.2,0.2,5.5,1.1s1.6,2.3,1.6,4.1v7L-814.4-259.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1084",
    className: "st3",
    d: "M440.6,339.6h3.3v16.8h-3.3V339.6z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPix30);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PIX-30.9a2097eaa76a993f6cb0619e2729e607.svg";